import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const ORIGIN = 1
export const DESTINATION = 2
export const FLIGHT = 3

export default new Vuex.Store({
  state: {
    origins: [
      { id: 'los_angeles', name: 'Los Angeles', img: './static/los_angeles.jpg' },
      { id: 'chicago', name: 'Chicago', img: './static/chicago.jpg' },
      { id: 'philadelphia', name: 'Philadelphia', img: './static/philadelphia.jpg' },
      { id: 'new_york_city', name: 'New York City', img: './static/new_york_city.jpg' },
      { id: 'houston', name: 'Houston', img: './static/houston.jpg' },
      { id: 'dallas', name: 'Dallas', img: './static/dallas.jpg' }
    ],
    destinations: {
      los_angeles: [
        { id: 'beach', name: 'Beach', img: './static/beach.jpg' },
        { id: 'party_hub', name: 'Party Hub', img: './static/party_hub.jpg' },
        { id: 'back_to_nature', name: 'Back to Nature', img: './static/back_to_nature.jpg' },
        { id: 'family_vacation', name: 'Family Vacation', img: './static/family_vacation.jpg' },
        { id: 'ski_resort', name: 'Snowy Adventure', img: './static/ski_resort.jpg' },
        { id: 'foodie_paradise', name: 'Foodie Paradise', img: './static/foodie.jpg' }
      ],
      dallas: [
        { id: 'beach', name: 'Beach', img: './static/beach.jpg' },
        { id: 'party_hub', name: 'Party Hub', img: './static/party_hub.jpg' },
        { id: 'back_to_nature', name: 'Back to Nature', img: './static/back_to_nature.jpg' },
        { id: 'family_vacation', name: 'Family Vacation', img: './static/family_vacation.jpg' },
        { id: 'ski_resort', name: 'Snowy Adventure', img: './static/ski_resort.jpg' },
        { id: 'foodie_paradise', name: 'Foodie Paradise', img: './static/foodie.jpg' }
      ],
      chicago: [
        { id: 'beach', name: 'Beach', img: './static/beach.jpg' },
        { id: 'party_hub', name: 'Party Hub', img: './static/party_hub.jpg' },
        { id: 'back_to_nature', name: 'Back to Nature', img: './static/back_to_nature.jpg' },
        { id: 'family_vacation', name: 'Family Vacation', img: './static/family_vacation.jpg' },
        { id: 'ski_resort', name: 'Snowy Adventure', img: './static/ski_resort.jpg' },
        { id: 'foodie_paradise', name: 'Foodie Paradise', img: './static/foodie.jpg' }
      ],
      philadelphia: [
        { id: 'beach', name: 'Beach', img: './static/beach.jpg' },
        { id: 'party_hub', name: 'Party Hub', img: './static/party_hub.jpg' },
        { id: 'back_to_nature', name: 'Back to Nature', img: './static/back_to_nature.jpg' },
        { id: 'family_vacation', name: 'Family Vacation', img: './static/family_vacation.jpg' },
        { id: 'ski_resort', name: 'Snowy Adventure', img: './static/ski_resort.jpg' },
        { id: 'foodie_paradise', name: 'Foodie Paradise', img: './static/foodie.jpg' }
      ],
      new_york_city: [
        { id: 'beach', name: 'Beach', img: './static/beach.jpg' },
        { id: 'party_hub', name: 'Party Hub', img: './static/party_hub.jpg' },
        { id: 'back_to_nature', name: 'Back to Nature', img: './static/back_to_nature.jpg' },
        { id: 'family_vacation', name: 'Family Vacation', img: './static/family_vacation.jpg' },
        { id: 'ski_resort', name: 'Snowy Adventure', img: './static/ski_resort.jpg' },
        { id: 'foodie_paradise', name: 'Foodie Paradise', img: './static/foodie.jpg' }
      ],
      houston: [
        { id: 'beach', name: 'Beach', img: './static/beach.jpg' },
        { id: 'party_hub', name: 'Party Hub', img: './static/party_hub.jpg' },
        { id: 'back_to_nature', name: 'Back to Nature', img: './static/back_to_nature.jpg' },
        { id: 'family_vacation', name: 'Family Vacation', img: './static/family_vacation.jpg' },
        { id: 'ski_resort', name: 'Snowy Adventure', img: './static/ski_resort.jpg' },
        { id: 'foodie_paradise', name: 'Foodie Paradise', img: './static/foodie.jpg' }
      ]
    },
    flights: {
      los_angeles: {
        beach: [
          {
            id: 2,
            origin: {
              city: 'Los Angeles',
              airport: 'LAX'
            },
            destination: {
              city: 'Miami',
              airport: 'MIA'
            },
            trip: {
              leave: 'Monday, Sep 4',
              return: 'Friday, Sep 8',
              duration: 5
            },
            airline: 'American Airlines',
            price: 133,
            details: false,
            attractions: false
          },
          {
            id: 1,
            origin: {
              city: 'Los Angeles',
              airport: 'LAX'
            },
            destination: {
              city: 'Fort Lauderdale',
              airport: 'FLL'
            },
            trip: {
              leave: 'Sunday, Sep 10',
              return: 'Friday, Sep 15',
              duration: 6
            },
            airline: 'American Airlines',
            price: 233,
            details: false,
            attractions: false
          },
          {
            id: 4,
            origin: {
              city: 'Los Angeles',
              airport: 'LAX'
            },
            destination: {
              city: 'Honolulu',
              airport: 'HNL'
            },
            trip: {
              leave: 'Monday, Sep 4',
              return: 'Saturday, Sep 9',
              duration: 6
            },
            airline: 'Alaska Airlines',
            price: 444,
            details: false,
            attractions: false
          },
          {
            id: 3,
            origin: {
              city: 'Los Angeles',
              airport: 'LAX'
            },
            destination: {
              city: 'Honolulu',
              airport: 'HNL'
            },
            trip: {
              leave: 'Thursday, Sep 7',
              return: 'Saturday, Sep 16',
              duration: 10
            },
            airline: 'Alaska Airlines',
            price: 456,
            details: false,
            attractions: false
          },
          {
            id: 5,
            origin: {
              city: 'Los Angeles',
              airport: 'LAX'
            },
            destination: {
              city: 'Myrtle Beach',
              airport: 'MYR'
            },
            trip: {
              leave: 'Friday, Sep 1',
              return: 'Tuesday, Sep 5',
              duration: 5
            },
            airline: 'United Airlines',
            price: 632,
            details: false,
            attractions: false
          }
        ]
      },
      dallas: {
        family_vacation: [
          {
            id: 7,
            origin: {
              city: 'Dallas/Fort Worth',
              airport: 'DFW'
            },
            destination: {
              city: 'San Diego',
              airport: 'SAN'
            },
            trip: {
              leave: 'Friday, Sep 15',
              return: 'Sunday, Sep 17',
              duration: 3
            },
            airline: 'Spirit Airlines',
            price: 221,
            details: false,
            attractions: false
          },
          {
            id: 8,
            origin: {
              city: 'Dallas/Fort Worth',
              airport: 'DFW'
            },
            destination: {
              city: 'San Diego',
              airport: 'SAN'
            },
            trip: {
              leave: 'Friday, Sep 15',
              return: 'Wednesday, Sep 20',
              duration: 6
            },
            airline: 'United Airlines',
            price: 298,
            details: false,
            attractions: false
          },
          {
            id: 6,
            origin: {
              city: 'Dallas/Fort Worth',
              airport: 'DFW'
            },
            destination: {
              city: 'Orlando',
              airport: 'MCO'
            },
            trip: {
              leave: 'Friday, Sep 1',
              return: 'Monday, Sep 4',
              duration: 4
            },
            airline: 'American Airlines',
            price: 322,
            details: false,
            attractions: false
          },
          {
            id: 7,
            origin: {
              city: 'Dallas/Fort Worth',
              airport: 'DFW'
            },
            destination: {
              city: 'San Diego',
              airport: 'SAN'
            },
            trip: {
              leave: 'Friday, Sep 15',
              return: 'Sunday, Sep 17',
              duration: 3
            },
            airline: 'American Airlines',
            price: 387,
            details: false,
            attractions: false
          }
        ]
      }
    },
    ata: {
      FLL: ['a345', 'a333'],
      MIA: ['a333', 'a345'],
      MCO: ['w345'],
      SAN: ['s321'],
      MYR: ['m321'],
      HNL: ['h321']
    },
    attractions: {
      a345: {
        name: 'Miami Beach',
        img: './static/miami_beach.jpg',
        description: 'Great beach with white sand and blue water.'
      },
      a333: {
        name: 'Fort Lauderdale Beach',
        img: './static/fort_lauderdale_beach.jpg',
        description: 'Great beach with white sand and blue water.'
      },
      w345: {
        name: 'Walt Disney World Resort',
        img: './static/walt_disney_world_resort.jpg',
        description: 'You can have a lot of fun here with or without kids.'
      },
      s321: {
        name: 'Legoland California Resort',
        img: './static/legoland_california_resort.jpg',
        description: 'Lot\'s of LEGOs here to see and play with.'
      },
      m321: {
        name: 'Myrtle Beach',
        img: './static/myrtle_beach.jpg',
        description: 'Great beach with white sand and blue water.'
      },
      h321: {
        name: 'Waikiki Beach',
        img: './static/waikiki_beach.jpg',
        description: 'Great beach with white sand and blue water.'
      }
    },
    scene: ORIGIN,
    origin: undefined,
    destination: undefined,
    flight: undefined
  },
  getters: {
    sceneIsOrigin: (state) => {
      return state.scene === ORIGIN
    },
    sceneIsDestination: (state) => {
      return state.scene === DESTINATION
    },
    sceneIsFlight: (state) => {
      return state.scene === FLIGHT
    },
    originIsUnknown: (state) => {
      return !state.origin
    },
    origin: (state) => {
      return state.origin
    }
  },
  mutations: {
    setOrigin (state, origin) {
      state.origin = origin
    },
    setDestination (state, destination) {
      state.destination = destination
    },
    setScene (state, scene) {
      state.scene = scene
    }
  },
  actions: {
    setOrigin ({ commit }, origin) {
      commit('setOrigin', origin)
      commit('setDestination', undefined)
      commit('setScene', DESTINATION)
    },
    setDestination ({ commit }, destination) {
      commit('setDestination', destination)
      commit('setScene', FLIGHT)
    },
    setSceneOrigin ({ commit }) {
      commit('setScene', ORIGIN)
    },
    setSceneDestination ({ commit }) {
      commit('setScene', DESTINATION)
    },
    setSceneFlight ({ commit }) {
      commit('setScene', FLIGHT)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js